/** @jsx jsx */
import { Box, Card, jsx } from "theme-ui";
import React from "react";
import Nav, { NavProps } from "./nav";

export type NavItemChildrenProps = NavProps;
export const NavItemChildren: React.FC<NavItemChildrenProps> = ({
  navItems,
  level,
  visible,
  variant,
}) => {
  //console.log("shild visible", visible);
  return (
    <Box
      variant={`${variant}.subMenu`}
      sx={{ display: visible ? "block" : "none", zIndex: "101" }}
    >
      <Nav navItems={navItems} level={level + 1} visible={visible} />
    </Box>
  );
};

export default NavItemChildren;
